/* eslint-disable */
const api = {
  getRulePocContent: '/privacy-new/privacy/evidence/show/rule/poc', // 获取要扫描的小程序列表
}

export default api;
